'use strict';
moduleConfig.registerModule('eclipseApp.socialMedia', ['eclipseApp.core']);
